export function toString<T>(obj: T): string {
    if (obj === null || obj === undefined) {
        return ''
    }

    return String(obj)
}

export type DateTimeFormatOptions = Pick<
    Intl.DateTimeFormatOptions,
    'year' | 'month' | 'day' | 'hour' | 'minute' | 'second'
>

export const defaultDateFormatOptions: DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
}

export const defaultTimeFormatOptions: DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
}

export const defaultDateTimeFormatOptions: DateTimeFormatOptions = {
    ...defaultDateFormatOptions,
    ...defaultTimeFormatOptions
}

export function toLocaleDateString(
    timestampOrDate: number | Date,
    timeZone?: string,
    options?: DateTimeFormatOptions
): string {
    if (typeof timestampOrDate === 'number') {
        timestampOrDate = new Date(timestampOrDate * 1000)
    }

    if (timeZone) {
        return timestampOrDate.toLocaleDateString(undefined, {
            ...(options || defaultDateTimeFormatOptions),
            timeZone
        })
    }
    return timestampOrDate.toLocaleDateString(undefined, options || defaultDateTimeFormatOptions)
}

export function toLocaleTimeString(
    timestampOrDate: number | Date,
    timeZone?: string,
    options?: DateTimeFormatOptions
): string {
    if (typeof timestampOrDate === 'number') {
        timestampOrDate = new Date(timestampOrDate * 1000)
    }

    if (timeZone) {
        return timestampOrDate.toLocaleTimeString(undefined, {
            ...(options || defaultTimeFormatOptions),
            timeZone
        })
    }
    return timestampOrDate.toLocaleTimeString(undefined, options || defaultTimeFormatOptions)
}
